import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
  selector: "field-set-radio",
  templateUrl: "./field-set-radio.component.html",
  styles: [],
  providers: [],
})
export class FieldSetRadioComponent {

  @Input() public fieldOptions: any = [];
  @Input() public guideIsBoolean: boolean = false;
  @Output() public dataChanged = new EventEmitter();
  public newSelection: string;

    public dropped(event: CdkDragDrop<any[]>) {
        if (event.previousContainer === event.container) {
            moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
        }
    }

  public addSelection(data) {
    this.fieldOptions.values.push({value: data, label: data});
  }

  public deleteSelection(isConfirmed, index: number) {
    if (isConfirmed) {
      this.fieldOptions.values.splice(index, 1);
    }
  }

  public clearForm(form) {
    form.reset();
  }

  public dataChangedEvent() {
    this.dataChanged.emit();
  }
}
